import { render, staticRenderFns } from "./AddInstitutionAccounts.vue?vue&type=template&id=a55ce7b4&"
import script from "./AddInstitutionAccounts.vue?vue&type=script&lang=js&"
export * from "./AddInstitutionAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports